import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const OnceliklendirmeExcel = () => {
    return (
        <>
            <ExcelUpload
                // onceliklendirme_veri_read
                role_name={"onceliklendirme_veri_write"}
                requiredColumnsSase={[
                    "sase", "priority"
                ]}
                process_type="PRIORITY"
                ExcelName={"Hatalı Öncelik Verileri"}
                Title={"Önceliklendirme"}
                exampleData={[
                    {
                        sase: "VR1JCYHZUPY572549",
                        priority: "3"
                    },
                    {
                        sase: "VR1JCYHZUPY572550",
                        priority: "4"
                    },
                    {
                        sase: "VR1JCYHZUPY572551",
                        priority: "5"
                    },
                    {
                        sase: "VR1JCYHZUPY572552",
                        priority: "99"
                    }
                ]}
            />
        </>
    )
}

export default OnceliklendirmeExcel